import { getText } from '../shared/customization';

export const setPageTitle = () => {
    document.title = getText('Page.Title');
  };